export enum LoggerLevel {
  NONE,
  ERROR,
  INFO,
  DEBUG
}

var serviceUrl: string = "";
var store: boolean = true;
var logLevel: LoggerLevel = LoggerLevel.ERROR;

var intDone: boolean = false;

export function LoggerLog(message?: any) {
  var date = new Date(Date.now());
  var utc = date.toUTCString();
  console.log(`${utc} - LOG - ${message}`);
}

export function LoggerError(message?: any) {
  var date = new Date(Date.now());
  var utc = date.toUTCString();
  console.error(`${utc} - ERR - ${message}`);
}

export function LoggerDbg(message?: any) {
  var date = new Date(Date.now());
  var utc = date.toUTCString();
  console.debug(`${utc} - DBG - ${message}`);
}

export function LoggerInfo(message?: any) {
  var date = new Date(Date.now());
  var utc = date.toUTCString();
  console.info(`${utc} - INF - ${message}`);
}

// export var loggerDbROpenReuest: IDBOpenDBRequest = undefined;
// export var loggerDatabase: IDBDatabase = undefined;

// (<any>window).indexedDB = <any>(<any>window).indexedDB || (<any>window).mozIndexedDB || (<any>window).webkitIndexedDB || (<any>window).msIndexedDB;
// (<any>window).IDBTransaction = (<any>window).IDBTransaction || (<any>window).webkitIDBTransaction || (<any>window).msIDBTransaction || { READ_WRITE: "readwrite" }; // This line should only be needed if it is needed to support the object's constants for older browsers
// (<any>window).IDBKeyRange = (<any>window).IDBKeyRange || (<any>window).webkitIDBKeyRange || (<any>window).msIDBKeyRange;

export function LoggerInit(level: LoggerLevel = LoggerLevel.DEBUG, useStore: boolean = false) {
  logLevel = level;
  if (!intDone) {
    // if (useStore) {
    //   if (!window.indexedDB) {
    //     old_console_log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
    //   } else {
    //     loggerDbROpenReuest = indexedDB.open("logerr");

    //     loggerDbROpenReuest.onupgradeneeded = (event: IDBVersionChangeEvent) => {
    //       if (!loggerDbROpenReuest.result.objectStoreNames.contains("log")) {
    //         loggerDbROpenReuest.result.createObjectStore("log", {
    //           autoIncrement: true,
    //           keyPath: "id"
    //         });
    //       }
    //       if (!loggerDbROpenReuest.result.objectStoreNames.contains("settings")) {
    //         loggerDbROpenReuest.result.createObjectStore("settings", {
    //           keyPath: "key"
    //         });
    //       }

    //       loggerDbROpenReuest.onerror = (event: Event) => {
    //         old_console_log("Logger dababase error !");
    //       };

    //       loggerDbROpenReuest.onsuccess = (event: Event) => {
    //         loggerDatabase = loggerDbROpenReuest.result;
    //       };
    //     };
    //   }
    // }

    intDone = true;
  }
}

// function saveToDB(message: string) {
//   if (loggerDatabase) {
//     let tran = loggerDatabase.transaction("log", "readwrite");
//     let store = tran.objectStore("log");
//     let dt = new Date();
//     let utc = dt.toUTCString();
//     let item = {
//       date: dt,
//       utc: utc,
//       msg: message
//     };
//     store.add(item);
//   }
// }

// export function setLoggerUser(userName: string) {}

// export function setLoggerClear(userName: string) {}

export function LoggerClass<T extends { new (...args: any[]): {} }>(constructor: T) {
  return class extends constructor {};
}

export function LoggerMethod(level?: LoggerLevel) {
  return (target, propertyKey: string, descriptor: PropertyDescriptor) => {
    LoggerInit();

    level = level ? level : logLevel;

    if (target && target["constructor"] && target["constructor"]["name"]) {
      descriptor["loggerClassName"] = target["constructor"]["name"];
    } else {
      descriptor["loggerClassName"] = "";
    }
    descriptor["loggerPropertyKey"] = `${descriptor["loggerClassName"]}:${propertyKey}`;

    if (descriptor["value"] && typeof descriptor["value"] == "function") {
      let mth: (...args: any[]) => any = descriptor["value"];
      descriptor["value"] = function(...args: any[]) {
        try {
          if (level >= LoggerLevel.DEBUG) {
            LoggerLog(`Call    : ${descriptor["loggerPropertyKey"]} ` + (args != undefined && args.length > 0 ? `args: ${args}` : ""));
          }

          var res = mth.call(this, ...args);
          if (level >= LoggerLevel.DEBUG) {
            LoggerLog(`Executed: ${descriptor["loggerPropertyKey"]} ` + (res != undefined ? `res: ${res}` : ""));
          }
          return res;
        } catch (error) {
          if (level != LoggerLevel.NONE) {
            LoggerError(`Error   : ${descriptor["loggerPropertyKey"]} error: ${error}\n ${prepareCallStack(new Error().stack)}`);
          }
        }
      };
    }
  };
}

function prepareCallStack(callStack: string) {
  var array = callStack.split("\n");
  if (array.length > 2) array.splice(1, 1);
  return array.join("\n");
}
